export const fixHourFormat = (number: number) => (number < 10 ? `0${number}` : number);
